// DOM adapter for the pure records renderer. The complete result stays in
// memory; scrolling swaps only a small, overscanned window into the document.
import {
  RECORD_VIRTUAL_ROW_HEIGHT,
  RECORD_VIRTUAL_WINDOW,
  renderRecordWindow,
  renderTableWindow,
  TABLE_RECORD_HEIGHT,
} from '../render/records-view.js';

const OVERSCAN = 10;

export function mountRecordVirtualization(root, result) {
  const tableViewport = root?.querySelector?.('.record-table-virtual');
  if (tableViewport) {
    const windowEl = tableViewport.querySelector('[data-table-window]');
    let frame = 0;
    const update = () => {
      frame = 0;
      const start = Math.min(Math.max(0, result.render.rows.length - RECORD_VIRTUAL_WINDOW), Math.max(0, Math.floor(tableViewport.scrollTop / TABLE_RECORD_HEIGHT) - OVERSCAN));
      if (Number(windowEl.dataset.start) === start) return;
      windowEl.innerHTML = renderTableWindow(result, start, RECORD_VIRTUAL_WINDOW, tableViewport.dataset.tableLayout === 'unified');
      windowEl.dataset.start = String(start);
      tableViewport.querySelector('[data-table-top] td').style.height = `${start * TABLE_RECORD_HEIGHT}px`;
      tableViewport.querySelector('[data-table-bottom] td').style.height = `${Math.max(0, result.render.rows.length - start - RECORD_VIRTUAL_WINDOW) * TABLE_RECORD_HEIGHT}px`;
    };
    const scroll = () => { if (!frame) frame = requestAnimationFrame(update); };
    tableViewport.addEventListener('scroll', scroll, { passive: true });
    return () => { tableViewport.removeEventListener('scroll', scroll); if (frame) cancelAnimationFrame(frame); };
  }
  const viewport = root?.querySelector?.('.record-virtual-viewport');
  const windowEl = viewport?.querySelector?.('.record-virtual-window');
  if (!viewport || !windowEl) return () => {};

  const total = result.render?.rows?.length || 0;
  const maxStart = Math.max(0, total - RECORD_VIRTUAL_WINDOW);
  let frame = 0;

  const update = () => {
    frame = 0;
    const wanted = Math.floor(viewport.scrollTop / RECORD_VIRTUAL_ROW_HEIGHT) - OVERSCAN;
    const start = Math.min(maxStart, Math.max(0, wanted));
    if (Number(windowEl.dataset.start) === start) return;
    const rendered = renderRecordWindow(result, start);
    windowEl.innerHTML = rendered.html;
    windowEl.dataset.start = String(rendered.start);
    windowEl.style.transform = `translateY(${rendered.start * RECORD_VIRTUAL_ROW_HEIGHT}px)`;
  };

  const onScroll = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  viewport.addEventListener('scroll', onScroll, { passive: true });

  return () => {
    viewport.removeEventListener('scroll', onScroll);
    if (frame) cancelAnimationFrame(frame);
  };
}
